import PaymentFeedback from './payment-feedback';

export default PaymentFeedback;
